var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 104,
    viewBox: "0 0 210 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.243 103.991C154.243 97.4246 152.95 90.9228 150.437 84.8566C147.924 78.7903 144.241 73.2783 139.598 68.6354C134.956 63.9925 129.444 60.3095 123.377 57.7967C117.311 55.284 110.809 53.9907 104.243 53.9907C97.677 53.9907 91.1752 55.284 85.109 57.7967C79.0427 60.3095 73.5307 63.9925 68.8878 68.6354C64.2449 73.2783 60.5619 78.7903 58.0492 84.8566C55.5364 90.9228 54.2431 97.4246 54.2431 103.991L154.243 103.991Z",
    fill: "#FF7E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.242 0L107.205 45.906H101.28L104.242 0Z",
    fill: "#FF7E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.923 3.78896L122.599 48.617L116.922 46.9181L132.923 3.78896Z",
    fill: "#FF7E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162.402 17.6181L139.658 57.6038L134.707 54.3487L162.402 17.6181Z",
    fill: "#FF7E6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.279 38.1049L152.025 69.8905L148.215 65.3525L185.279 38.1049Z",
    fill: "#FF7E6B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.32 64.2906L160.349 85.2069L158 79.7671L201.32 64.2906Z",
    fill: "#FF7E6B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M209.181 93.9762L163.933 102.267L163.242 96.3821L209.181 93.9762Z",
    fill: "#FF7E6B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.818359 81.3357L46.181 88.9755L44.8227 94.7429L0.818359 81.3357Z",
    fill: "#FF7E6B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2109 52.8176L53.4784 73.1431L50.5235 78.2789L12.2109 52.8176Z",
    fill: "#FF7E6B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3019 28.7633L65.0089 60.0678L60.7056 64.1407L31.3019 28.7633Z",
    fill: "#FF7E6B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4871 11.1925L79.8031 50.8473L74.5126 53.5153L56.4871 11.1925Z",
    fill: "#FF7E6B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9743 2.54852L92.9414 47.2236L87.1081 48.2627L81.9743 2.54852Z",
    fill: "#FF7E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.b9a00a92d35b24f712ca516542f5c9cc.svg";
export { ForwardRef as ReactComponent };